import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { doLogin, selectUser, fetchGoogleConfig, selectGoogleConfig, doGoogleLogin, fetchFacebookConfig, selectFacebookConfig, doFacebookLogin } from './LoginSlice';
import styles from './Login.module.css';
import Nav from '../../components/nav/Nav';
import Chart from '../chart/Chart';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import FacebookLoginButton from '../../components/auth/FacebookLoginButton';
const Login = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(selectUser);
  const googleConfig = useSelector(selectGoogleConfig);
  const facebookConfig = useSelector(selectFacebookConfig);
  //TEMP
  const [showG, setShowG] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });

  /**
   * Function to handle form input changes.
   * @param {*} e
   */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const login = () => {
    dispatch(doLogin(formData));
  }

  const goToSignup = () => {
    history.push('/signup')
  }

  /**
   * Function to handle Google SSO login success
   */
  const handleGoogleSuccess = (credentialResponse) => {
    if (credentialResponse?.credential) {
      dispatch(doGoogleLogin(credentialResponse.credential));
    }
  };

  /**
   * Function to handle Google SSO login error
   */
  const handleGoogleError = () => {
    console.error('Google Sign-In failed');
  };

  /**
   * Function to handle Facebook SSO login success
   */
  const handleFacebookSuccess = (accessToken) => {
    if (accessToken) {
      dispatch(doFacebookLogin(accessToken));
    }
  };

  /**
   * Function to handle Facebook SSO login error
   */
  const handleFacebookError = (error) => {
    console.error('Facebook Sign-In failed:', error);
  };

  useEffect(() => {
      //clear local storage
      localStorage.removeItem('userObject');
      dispatch(fetchGoogleConfig());
      dispatch(fetchFacebookConfig());
  }, [dispatch]);

  useEffect(() => {
  
    if (user && Object.keys(user).length) {
      history.push('/home');
    }
  }, [user, history]);

  return (
    <div className="container-fluid">
      <div className={`row ${styles.container}`}>
        <Nav />
  
        <section className={styles.hero}>
          <div className={styles.heroContent}>
            <h1>Your Investment Journey Starts Here</h1>
            <p>Unlock the potential of your investments with FundFolio.</p>
            <button className={styles.ctaButton} onClick={goToSignup}>Go To Signup</button>
            <button className='btn btn-info' onClick={() => setShowG(true)}>Show Chart</button>
          </div>
        </section>
        {showG && <section>
          <Chart type={'candle'} />
          <input type='button' value='CLOSE' onClick={() => setShowG(false)} />
        </section>
        }
  
        <section>
          <div className='col-md-6 m-auto'>
            <h4>LOGIN PAGE</h4>
            <form>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input 
                  type="text" 
                  className="form-control" 
                  id="email" 
                  name="email" 
                  value={formData.email} 
                  onChange={handleChange}
                  aria-label="Email address"
                />
              </div>
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input 
                  type="password" 
                  className="form-control" 
                  id="password" 
                  name="password" 
                  value={formData.password} 
                  onChange={handleChange}
                  aria-label="Password"
                />
              </div>
              <input type="button" className="btn btn-primary mt-2" disabled={!formData.email || !formData.password} onClick={login} value='LOGIN' />
            </form>

            {(googleConfig?.clientId || facebookConfig?.appId) && (
            <>
            <div className="d-flex align-items-center my-3">
              <hr className="flex-grow-1" />
              <span className="px-3 text-muted">or</span>
              <hr className="flex-grow-1" />
            </div>

            <div className="d-flex flex-column align-items-center gap-2">
              {googleConfig?.clientId && (
                <GoogleOAuthProvider clientId={googleConfig.clientId}>
                  <GoogleLogin
                    onSuccess={handleGoogleSuccess}
                    onError={handleGoogleError}
                    text="signin_with"
                    shape="rectangular"
                  />
                </GoogleOAuthProvider>
              )}
              {facebookConfig?.appId && (
                <FacebookLoginButton
                  appId={facebookConfig.appId}
                  onSuccess={handleFacebookSuccess}
                  onError={handleFacebookError}
                  text="signin_with"
                />
              )}
            </div>
            </>
            )}
          </div>
        </section>
        <section className={styles.features}>
          <div className={styles.feature}>
            <h2>Feature 1</h2>
            <p>Feature 1 description goes here.</p>
          </div>
          <div className={styles.feature}>
            <h2>Feature 2</h2>
            <p>Feature 2 description goes here.</p>
          </div>
          <div className={styles.feature}>
            <h2>Feature 3</h2>
            <p>Feature 3 description goes here.</p>
          </div>
        </section>
        <section className={styles.contact}>
          <h2>Contact Us</h2>
          <p>If you have any questions, feel free to contact us.</p>
          <a href="/contact" className={styles.contactButton}>Contact Us</a>
        </section>
      </div>
    </div>
  )
}

export default Login;
